import { Box } from "@material-ui/core"
import SingleButtonSelection from "components/Reusable/Bit/SingleButtonSelection"
import { FormikProps } from "formik"
import styled from "styled-components"
import colors from "theme/colors"

const StyledButton = styled(Box)<{ $isSelected?: boolean }>`
  width: 150px;
  height: 40px;
  margin-top: 12px;
  background-color: ${(p) => (p.$isSelected ? colors.darkGreen : colors.grey)};
  color: ${(p) => (p.$isSelected ? colors.white : colors.warmGray)};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: NarkisBlock;
  font-size: 20px;
  font-weight: bold;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
    height: 48px;
    margin-left: 10px;
    font-size: 24px;
  }

  :hover {
    border: 1px solid ${colors.darkGreen};
  }
`
const StyledLabel = styled.label<{ $activeButton: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  :focus {
    outline: none;
  }
`

const StyledButoonWrapper = styled(Box)`
  button {
    ${(p) => p.theme.breakpoints.down("sm")} {
      width: 50%;
    }
  }
`

type PurchaseButtonProps = {
  blessingType: string
  handleSelectMode: (mode: string) => void
  formik: FormikProps<{}>
  blessingMode: string
}

const PurchaseButton = ({
  handleSelectMode,
  blessingType,
  formik,
  blessingMode,
}: PurchaseButtonProps) => {
  const buttons =
    blessingType === "Myself"
      ? [{ value: 0, text: "לעצמי", type: "short" }]
      : blessingType === "Another"
      ? [{ value: 0, text: "למישהי / מישהו", type: "full" }]
      : [
          { value: 0, text: "למישהי / מישהו", type: "full" },
          { value: 1, text: "לעצמי", type: "short" },
        ]

  const handleButtonClick = async (code) => {
    handleSelectMode(buttons[code].type)
    await formik.validateForm()
    formik.setTouched({ ...formik.touched })
  }

  return (
    <StyledButoonWrapper>
      <SingleButtonSelection
        id="routesSelect"
        items={buttons.map((amount) => ({
          value: amount.value,
          name: amount.text,
        }))}
        onSelect={(code) => handleButtonClick(code)}
        gap={15}
        selectedValue={blessingMode && blessingMode === "short" ? 1 : 0}
        itemsPerRow={"auto"}
        customButton={(radioId, isSelected, item) => {
          return (
            <>
              <StyledLabel htmlFor={radioId} $activeButton={isSelected}>
                <StyledButton $isSelected={isSelected}>
                  <>{item.name}</>
                </StyledButton>
              </StyledLabel>
            </>
          )
        }}
      />
    </StyledButoonWrapper>
  )
}

export default PurchaseButton
